import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "@/lib/i18n";

export function LanguageToggle() {
  const { lang, setLang } = useLang();
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  const opt = (l, label) => (
    <button
      type="button"
      onClick={() => setLang(l)}
      className={`rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${lang === l ? "bg-[#D4AF37] text-[#1A1715]" : "text-[#A8A29E] hover:text-[#FDFBF7]"}`}
      aria-pressed={lang === l}
      data-testid={`lang-${l}-btn`}
    >
      {label}
    </button>
  );
  return (
    <div className="fixed right-3 top-3 z-50 flex items-center gap-0.5 rounded-full border border-white/15 bg-[#1A1715]/80 p-1 backdrop-blur-md sm:right-5 sm:top-5" data-testid="language-toggle">
      {opt("no", "NO")}
      {opt("en", "EN")}
    </div>
  );
}

export function BackButton({ to = "/gave", testid = "page-back-btn" }) {
  const { t } = useLang();
  return (
    <Link
      to={to}
      className="absolute left-0 top-1/2 inline-flex -translate-y-1/2 items-center gap-1.5 rounded-full border border-white/15 bg-[#1A1715]/60 px-3 py-2 text-xs text-[#FDFBF7] backdrop-blur-md transition-colors hover:border-[#D4AF37] hover:text-[#D4AF37]"
      data-testid={testid}
    >
      <ArrowLeft className="h-4 w-4" /> {t("Tilbake", "Back")}
    </Link>
  );
}
